import {Inject, Injectable} from '@angular/core';
import {ENV_CONFIG, EnvironmentConfig} from "../shared/environment-config.interface";

@Injectable()
export class ApiService {

  public apiUrl: string;
  public sqlKey: string = btoa("101104-260170");

  constructor(@Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.apiUrl = `${config.environment.baseUrl}`;
  }
}
